import { Link } from "react-router-dom";
import { Mail, Phone, MapPin, ArrowUpRight } from "lucide-react";
import { company, contact, nav_links } from "../data";

export default function Footer() {
  return (
    <footer className="border-t border-ink-700 bg-ink-950 mt-24" data-testid="site-footer">
      <div className="section-padding pt-20 pb-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-5">
            <p className="overline mb-4">Cea // Patna</p>
            <h3 className="font-display font-black text-3xl md:text-5xl tracking-tight leading-[0.95] mb-6">
              Engineering<br/>
              <span className="text-signal-amber">precision delivered.</span>
            </h3>
            <p className="text-textmuted text-sm leading-relaxed max-w-md">
              Choudhary Electronics Pvt. Ltd. — supplying laboratories, industries and
              automation projects across India since 2013.
            </p>
            <Link to="/enquiry" className="btn-primary mt-8" data-testid="footer-cta">
              Start an enquiry <ArrowUpRight size={14} />
            </Link>
          </div>

          <div className="md:col-span-3">
            <p className="overline mb-4">Navigate</p>
            <ul className="space-y-2">
              {nav_links.map((l) => (
                <li key={l.to}>
                  <Link
                    to={l.to}
                    data-testid={`footer-link-${l.label.toLowerCase()}`}
                    className="font-mono text-sm text-textmain hover:text-signal-amber transition-colors"
                  >
                    — {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <p className="overline mb-4">Reach us</p>
            <ul className="space-y-3 text-sm font-mono text-textmain">
              <li className="flex items-start gap-3">
                <MapPin size={14} className="text-signal-amber mt-1 flex-shrink-0" />
                <span className="text-textmuted leading-relaxed">{contact.head_office.address}</span>
              </li>
              <li className="flex items-center gap-3">
                <Phone size={14} className="text-signal-amber flex-shrink-0" />
                <a href={`tel:${contact.head_office.phones[0]}`} className="hover:text-signal-amber transition-colors">
                  {contact.head_office.phones.join("  /  ")}
                </a>
              </li>
              <li className="flex items-center gap-3">
                <Mail size={14} className="text-signal-amber flex-shrink-0" />
                <a href={`mailto:${contact.head_office.emails[0]}`} className="hover:text-signal-amber transition-colors">
                  {contact.head_office.emails[0]}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-6 border-t border-ink-700 flex flex-col md:flex-row md:items-center justify-between gap-4">
          <p className="font-mono text-[11px] tracking-[0.2em] uppercase text-textmuted">
            © {new Date().getFullYear()} CEATECH  LABS  PVT  LTD
          </p>
          <p className="font-mono text-[11px] tracking-[0.2em] uppercase text-textmuted flex items-center gap-2">
            <span className="dot-phosphor" /> SYS.ONLINE · EST.2013
          </p>
        </div>
      </div>
    </footer>
  );
}
